import { axios } from "../../config/axiosConfig";
import { endpoints } from "../../config/apiConfig";
import { identity } from "lodash";
import apiCall from "axios";

async function getAllContactTypes(data) {
  return axios
    .post(endpoints.contactTypes.getAllContactTypes, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}
async function getAllContactDataFields(id) {
  return axios
    .get(endpoints.contactTypes.getAllContactDataFields + id)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}
async function getAllContactModules(id) {
  return axios
    .get(endpoints.contactTypes.getAllContactModules + id)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}
async function getAllConnections(id) {
  return axios
    .get(endpoints.contactTypes.getAllConnections + id)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}
async function getAllContactAreas() {
  return axios
    .get(endpoints.contactTypes.getAllContactAreas)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}
async function getAllOFisRoles() {
  return axios
    .get(endpoints.contactTypes.getAllOfishRoles)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}
async function getAllContactDataFieldsById(id) {
  console.log("_id", id);
  return axios
    .get(
      `${endpoints.contactTypes.getAllContactDataFieldsById}` + `?fieldId=${id}`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function deleteContactTypeData(id) {
  return axios
    .post(`${endpoints.contactTypes.deleteContactTypeById}`, { id })
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

// async function getContactTypeDetailByID(contactTypeID) {
//   return axios
//     .get(endpoints.companies.deleteCompanies + contactTypeID)
//     .then(response => {
//       let data = response.data;
//       return data;
//     })
//     .catch(error => {
//       return null;
//     });
// }

// async function updateContactTypeStatusByID(contactTypeID) {
//   return axios
//     .delete(endpoints.customerGroups.deleteCustomerGroups, {
//       data: JSON.stringify(ids),
//     })
//     .then(response => {
//       let data = response.data;
//       return data;
//     })
//     .catch(error => {
//       return null;
//     });
// }

// async function addContactType(contactType) {
//   return axios
//     .post(endpoints.customerGroups.addCustomerGroups, {
//       name: value,
//     })
//     .then(response => {
//       let data = response.data;
//       return data;
//     })
//     .catch(error => {
//       return null;
//     });
// }

// async function updateContactType(contactType) {
//   return axios
//     .post(`${endpoints.customers.updateContact}${contactType.ContactTypeID}`, JSON.stringify(contactType))
//     .then(response => {
//       let data = response.data;
//       return data;
//     })
//     .catch(error => {
//       return null;
//     });
// }
async function getContactTypesModulesFiledsSettingsById(id) {
  return axios
    .get(
      `${endpoints.contactTypes.getContactTypesModulesFiledsSettingsById}` +
        `?fieldId=${id}`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function addUpdateContactType(data) {
  return axios
    .post(endpoints.contactTypes.addUpdateContactType, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getContactTypesById(id) {
  return axios
    .get(
      `${endpoints.contactTypes.getContactTypesById}` + `?ContactTypeId=${id}`
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function addUpdateMarkFavouriteContactTypes(data) {
  return axios
    .post(endpoints.contactTypes.addUpdateMarkFavouriteContactTypes, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function addUpdateMarkFavouriteContactTypesModules(data) {
  return axios
    .post(
      endpoints.contactTypes.addUpdateMarkFavouriteContactTypesModules,
      data
    )
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function addUpdateMarkFavouriteOfishConnections(data) {
  return axios
    .post(endpoints.contactTypes.addUpdateMarkFavouriteOfishConnections, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getFavouriteUsers() {
  return axios
    .post(`${endpoints.customers.getFavouriteUsers}`)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getStoreLocationsByCompanyId(id) {
  return axios
    .get(endpoints.contactTypes.getStoreLocationsByCompanyId(id))
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getLeadsPaginatedData(data) {
  return axios
    .post(endpoints.leadGenerations.getLeadsPaginatedData, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function updateLeadGeneration(data) {
  return axios
    .post(endpoints.leadGenerations.updateLeadGeneration, data)
    .then(response => {
      return response?.data;
    })
    .catch(error => {
      console.error("errorMessage ", error);
      return null;
    });
}

async function getLeadGeneration(id) {
  try {
    const response = await axios.get(
      `${endpoints.leadGenerations.getLeadGeneration}?${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching lead generation data:", error);
    return null;
  }
}

async function getCompaignByLeadId(id) {
  try {
    const response = await axios.get(
      `${endpoints.leadGenerations.getCompaignByLeadId}/${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching lead generation data:", error);
    return null;
  }
}

async function getProspectsPaginatedData(data) {
  return axios
    .post(endpoints.prospect.getProspectPaginatedData, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getProspectNotes(data) {
  return axios
    .post(endpoints.prospect.getProspectNotes, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function addProspectNotes(data) {
  return axios
    .post(endpoints.prospect.addProspectNotes, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getProspectById(id) {
  try {
    const response = await axios.get(
      `${endpoints.prospect.getProspectById}${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching lead generation data:", error);
    return null;
  }
}

async function addProspectFollowUp(data) {
  return axios
    .post(endpoints.prospect.addProspectFollowUp, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getProspectFollowUp(data) {
  return axios
    .post(endpoints.prospect.getProspectFollowUp, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getProspectInteraction(data) {
  return axios
    .post(endpoints.prospect.getProspectInteraction, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function addProspectInteraction(data) {
  return axios
    .post(endpoints.prospect.addProspectInteraction, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function addProspect(data) {
  return axios
    .post(endpoints.prospect.addProspect, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function uploadProspect(prospect) {
  let formData = new FormData();
  formData.append("file", prospect);

  const token = localStorage.getItem("access_token");
  return apiCall({
    url: endpoints.prospect.uploadProspect,
    method: "post",
    data: formData,
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  })
    .then(response => {
      let data = response?.data ?? null;
      return data;
    })
    .catch(error => {
      console.error("Upload prospect error:", error);
      throw error; // Important: re-throw the error so it can be caught in the component
    });
}

async function convertProspect(data) {
  return axios
    .post(endpoints.prospect.convertProspect, data)
    .then(data => {
      return data;
    })
    .catch(error => {
      return null;
    });
}

async function getVoiceToken() {
  try {
    const response = await axios.get(`${endpoints.prospect.getVoiceToken}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching lead generation data:", error);
    return null;
  }
}

async function deleteProspect(id) {
  try {
    const response = await axios.post(
      `${endpoints.prospect.deleteProspect}${id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error on delete prospect:", error);
    return null;
  }
}

async function getAllProspectsList() {
  try {
    const response = await axios.get(
      `${endpoints.prospect.getAllProspectsList}`
    );
    return response.data;
  } catch (error) {
    console.error("Error on get all prospects list:", error);
    return null;
  }
}

export const contactsApi = {
  getAllContactTypes: getAllContactTypes,
  getAllContactDataFields: getAllContactDataFields,
  getAllContactModules: getAllContactModules,
  getAllConnections: getAllConnections,
  getAllContactAreas: getAllContactAreas,
  getAllOFisRoles: getAllOFisRoles,
  getAllContactDataFieldsById: getAllContactDataFieldsById,
  // getContactTypeDetailByID: getContactTypeDetailByID,
  // updateContactTypeStatusByID: updateContactTypeStatusByID,
  // addContactType: addContactType,
  // updateContactType: updateContactType,
  getContactTypesModulesFiledsSettingsById:
    getContactTypesModulesFiledsSettingsById,
  addUpdateContactType: addUpdateContactType,
  getContactTypesById: getContactTypesById,
  addUpdateMarkFavouriteContactTypes: addUpdateMarkFavouriteContactTypes,
  addUpdateMarkFavouriteContactTypesModules:
    addUpdateMarkFavouriteContactTypesModules,
  addUpdateMarkFavouriteOfishConnections:
    addUpdateMarkFavouriteOfishConnections,
  getFavouriteUsers: getFavouriteUsers,
  getStoreLocationsByCompanyId: getStoreLocationsByCompanyId,
  getLeadsPaginatedData: getLeadsPaginatedData,
  updateLeadGeneration: updateLeadGeneration,
  getLeadGeneration: getLeadGeneration,
  getCompaignByLeadId: getCompaignByLeadId,
  deleteContactTypeData: deleteContactTypeData,
  getProspectsPaginatedData: getProspectsPaginatedData,
  getProspectNotes: getProspectNotes,
  addProspectNotes: addProspectNotes,
  getProspectById: getProspectById,
  addProspectFollowUp: addProspectFollowUp,
  getProspectFollowUp: getProspectFollowUp,
  getProspectInteraction: getProspectInteraction,
  addProspectInteraction: addProspectInteraction,
  addProspect: addProspect,
  uploadProspect: uploadProspect,
  convertProspect: convertProspect,
  getVoiceToken: getVoiceToken,
  deleteProspect: deleteProspect,
  getAllProspectsList: getAllProspectsList,
};
